import { useEffect, useRef } from "react";
import {SQFT_VIEW_MODE} from "../constants";

const useSqftWorkspaceModeTransition = ({
                                          SQFTViewMode,
                                          onEnter2D, // optional () => void | Promise<void>
                                          onLeave2D, // optional () => void | Promise<void>
                                        }) => {
  const prevModeRef = useRef(null);

  useEffect(() => {
    const prevMode = prevModeRef.current;
    prevModeRef.current = SQFTViewMode;

    // Skip first render - prevents wiping initial quote import
    if (prevMode === null) {
      return;
    }

    // 1) No real change
    if (prevMode === SQFTViewMode) {
      return;
    }

    // 2) mode-specific hooks
    if (prevMode === SQFT_VIEW_MODE.twoDMode && typeof onLeave2D === "function") {
      onLeave2D();
    }

    if (SQFTViewMode === SQFT_VIEW_MODE.twoDMode && typeof onEnter2D === "function") {
      onEnter2D();
    }
  }, [SQFTViewMode, onEnter2D, onLeave2D]);
};

export default useSqftWorkspaceModeTransition;
